import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApprovalTabs } from '@/components/approvals/ApprovalTabs';
import { ApprovalCard } from '@/components/approvals/ApprovalCard';
import { ApprovalDetailDrawer } from '@/components/approvals/ApprovalDetailDrawer';
import {
  useApprovalCounts,
  useApprovals,
  type ApprovalTab,
} from '@/hooks/useApprovals';
import { PullToRefresh } from '@/components/PullToRefresh';
import '@/styles/approvals.css';

export function ApprovalsRoute() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<ApprovalTab>('pending');
  const [detailId, setDetailId] = useState<string | null>(null);
  const { data: items = [], isLoading, refetch } = useApprovals(tab);
  const { data: counts } = useApprovalCounts();

  return (
    <PullToRefresh onRefresh={async () => { await refetch(); }}>
      <div className="appr-page">
        <ApprovalTabs current={tab} onChange={setTab} pendingCount={counts?.pending ?? 0} />

        {isLoading ? (
          <div className="appr-empty" aria-busy="true" />
        ) : items.length === 0 ? (
          <div className="appr-empty">
            <span className="material-symbols-outlined">inbox</span>
            {t(`approvals.empty_${tab}`)}
          </div>
        ) : (
          items.map((item) => (
            <ApprovalCard key={item.id} item={item} onOpen={() => setDetailId(item.id)} />
          ))
        )}

        <ApprovalDetailDrawer
          taskId={detailId}
          onClose={() => setDetailId(null)}
          allowActions={tab === 'pending'}
        />
      </div>
    </PullToRefresh>
  );
}
